export const locales = ['en', 'de', 'fr', 'ar']

export const defaultLocale = 'en'

export type Locale = 'en' | 'de' | 'fr' | 'ar'

export const LANGUAGE_COOKIE = 'sv_lang'

export const isLocale = (value: unknown): value is Locale =>
    typeof value === 'string' && locales.includes(value)

export const localeDir = (locale: Locale): 'rtl' | 'ltr' => locale === 'ar' ? 'rtl' : 'ltr'

export const LANGUAGE_OPTIONS: Array<{ code: Locale, label: string, flag: 'gb' | 'de' | 'fr' | 'tn', continueLabel: string }> = [
    { code: 'en', label: 'English', flag: 'gb', continueLabel: 'Continue' },
    { code: 'de', label: 'Deutsch', flag: 'de', continueLabel: 'Weiter' },
    { code: 'fr', label: 'Français', flag: 'fr', continueLabel: 'Continuer' },
    { code: 'ar', label: 'العربية', flag: 'tn', continueLabel: 'متابعة' }
]

export const pickLocaleFromHeader = (header: string | undefined): Locale => {
    if (!header) return 'en'

    const ranked = header
        .split(',')
        .map(part => {
            const [tag, q] = part.trim().split(';q=')

            return { tag: tag.toLowerCase().split('-')[0], q: q ? Number(q) : 1 }
        })
        .sort((a, b) => b.q - a.q)

    const match = ranked.find(entry => isLocale(entry.tag))

    return match && isLocale(match.tag) ? match.tag : 'en'
}
